import { TentTypeV1 } from '@camp67/model';
import { getPrice as getModelPrice } from '@camp67/model/booking/price';
import { getOfferingPrice, offeringsState } from './offerings';

/**
 * Get price for a tent type, preferring offerings data over hardcoded model prices
 */
export const getPrice = (tentType: TentTypeV1): number => {
  // Try to get price from offerings first
  if (offeringsState.initialized) {
    const offeringPrice = getOfferingPrice(tentType);
    if (offeringPrice !== undefined) {
      return offeringPrice;
    }
  }
  // Fall back to model's hardcoded prices
  return getModelPrice(tentType);
};

export const getLowestPricedTentPrice = () => {
  return getPrice(
    Object.values(TentTypeV1).reduce((lowest, tentType) => {
      const price = getPrice(tentType);
      return price < getPrice(lowest) ? tentType : lowest;
    }),
  );
};

export const getLowestPricedTent = () => {
  return Object.values(TentTypeV1).reduce((lowest, tentType) => {
    const price = getPrice(tentType);
    return price < getPrice(lowest) ? tentType : lowest;
  });
};

export const getLowestPriceTag = () => {
  const tentType = getLowestPricedTent();
  return getPriceTag(tentType);
};

export const getPriceTag = (tentType: TentTypeV1, includeRsPrefix = true) => {
  const price = getPrice(tentType);
  return `${includeRsPrefix ? 'RS. ₹' : '₹'}${price.toLocaleString()}`;
};
